import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAccountDetails, getEnvInfo } from "./accountSlice";
import { getUserDetails } from "./userSlice";

// THUNK
export const masterLoginUser = createAsyncThunk(
    'auth/masterLogin',
    async (credentials, { rejectWithValue, dispatch }) => {
    try {
        console.log('masterLoginUser - credentials:', { ...credentials, password: '***' });
        
        // Logica di crittografia della password
        const url = `${import.meta.env.VITE_API_BASE_URL}/auth/masterLogin`;
        const headers = { 'Content-Type': 'application/json' };
        const options = { method: 'POST', headers, body: JSON.stringify(credentials) };
        
        console.log('masterLoginUser - URL:', url);
        console.log('masterLoginUser - headers:', JSON.stringify(headers));
        
        const response = await fetch(url, options);
        console.log('masterLoginUser - response status:', response.status);
        
        if (!response.ok) {
            const error = await response.json();
            console.error('masterLoginUser - error:', error);
            return rejectWithValue({
                message: error.message || `Errore ${error.code}:`
            })
        }
        const result = await response.json();
        console.log('masterLoginUser - result:', { ...result, token: result.token ? 'presente' : 'non presente' });
        
        // Salvo i dati nel localStorage
        localStorage.setItem('installamelo-auth-token', result.token);
        localStorage.setItem('installamelo-auth-user', JSON.stringify({
            userId: result.userId,
            identityId: result.identityId,
            accountId: result.accountId,
            customerId: result.customerId
        }));
        
        console.log('masterLoginUser - token salvato in localStorage:', result.token ? 'presente' : 'non presente');
        console.log('masterLoginUser - user salvato in localStorage:', JSON.stringify({
            userId: result.userId,
            identityId: result.identityId,
            accountId: result.accountId
        }));

        // Avvio le chiamate successive in parallelo
        Promise.all([
            dispatch(getAccountDetails({
                accountId: result.accountId,
                token: result.token
            })),
            dispatch(getUserDetails({
                accountId: result.accountId,
                userId: result.userId,
                customerId: result.customerId || null,
                customerUserId: result.customerUserId || null,
                token: result.token
            })),
            dispatch(getEnvInfo())
        ]).catch(error => {
            console.error("Errore nel caricamento dei dati.", error)
        })

        return result
    } catch (error) {
        console.error('masterLoginUser - catch error:', error);
        return rejectWithValue({
            message: (error instanceof Error) ? error.message : 'Errore di rete. Riprova più tardi.'
        });
    }
})

export const loginUser = createAsyncThunk(
    'auth/login',
    async (credentials, { rejectWithValue, dispatch }) => {
    try {
        console.log('loginUser - credentials:', { ...credentials, password: '***' });
        
        // Logica di crittografia della password
        const url = `${import.meta.env.VITE_API_BASE_URL}/auth/login`;
        const headers = { 'Content-Type': 'application/json' };
        const options = { method: 'POST', headers, body: JSON.stringify(credentials) };
        
        console.log('loginUser - URL:', url);
        console.log('loginUser - headers:', JSON.stringify(headers));
        
        const response = await fetch(url, options);
        console.log('loginUser - response status:', response.status);
        
        if (!response.ok) {
            const error = await response.json();
            console.error('loginUser - error:', error);
            return rejectWithValue({
                message: error.message || `Errore ${error.code}:`
            })
        }
        const result = await response.json();
        console.log('loginUser - result:', { ...result, token: result.token ? 'presente' : 'non presente' });
        
        // Salvo i dati nel localStorage, ora includiamo anche l'oggetto user completo
        const userData = {
            userId: result.userId,
            identityId: result.identityId,
            accountId: result.accountId,
            customerId: result.customerId || null,
            customerUserId: result.customerUserId || null,
            // Salviamo anche i dati dell'utente completi dal nuovo oggetto user
            ...(result.user ? {
                name: result.user.name || '',
                surname: result.user.surname || '',
                email: result.user.email || '',
                phone: result.user.phone || '',
                typeId: result.user.typeId || '',
                typeLabel: result.user.typeLabel || '',
                roleId: result.user.roleId || '',
                roleLabel: result.user.roleLabel || '',
                welcomePage: result.user.welcomePage || '',
                admin: result.user.admin || false
            } : {})
        };
        
        localStorage.setItem('installamelo-auth-token', result.token);
        localStorage.setItem('installamelo-auth-user', JSON.stringify(userData));
        
        console.log('loginUser - token salvato in localStorage:', result.token ? 'presente' : 'non presente');
        console.log('loginUser - user salvato in localStorage:', JSON.stringify(userData));
        console.log('loginUser - dati user completi ricevuti:', result.user ? JSON.stringify(result.user) : 'nessun dato user');

        // Avvio le chiamate successive in parallelo
        Promise.all([
            dispatch(getAccountDetails({
                accountId: result.accountId,
                token: result.token
            })),
            dispatch(getUserDetails({
                accountId: result.accountId,
                userId: result.userId,
                customerId: result.customerId || null,
                customerUserId: result.customerUserId || null,
                token: result.token
            })),
            dispatch(getEnvInfo())
        ]).catch(error => {
            console.error("Errore nel caricamento dei dati.", error)
        })

        return result
    } catch (error) {
        console.error('loginUser - catch error:', error);
        return rejectWithValue({
            message: (error instanceof Error) ? error.message : 'Errore di rete. Riprova più tardi.'
        });
    }
})


// Definizione dello stato iniziale
const initialState = {
    user: null,
    token: null,
    isAuthenticated: false,
    isLoading: false,
    error: null
}

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        clearError: (state) => {
            state.error = null
        },
        getLogout: (state) => {
            localStorage.removeItem('installamelo-auth-user');
            localStorage.removeItem('installamelo-auth-token');
            state.user = null;
            state.token = null;
            state.isAuthenticated = false;
            state.isLoading = false;
        },
        getLogged: (state, action) => {
            state.user = action.payload;
            state.token = localStorage.getItem('installamelo-auth-token');
            state.isAuthenticated = true;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(loginUser.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(loginUser.rejected, (state, action) => {
                console.log(action.payload)
                state.error = action.payload?.message || "Errore sconosciuto.";
                state.isLoading = false;
            })
            .addCase(loginUser.fulfilled, (state, action) => {
                state.isAuthenticated = true;
                state.token = action.payload.token;
                
                // Creiamo un oggetto user completo con tutti i dati ricevuti dall'API
                state.user = {
                    userId: action.payload.userId,
                    identityId: action.payload.identityId,
                    accountId: action.payload.accountId,
                    customerId: action.payload.customerId || null,
                    customerUserId: action.payload.customerUserId || null,
                    // Aggiungiamo i dati dell'utente completi dall'oggetto user
                    ...(action.payload.user ? {
                        name: action.payload.user.name || '',
                        surname: action.payload.user.surname || '',
                        email: action.payload.user.email || '',
                        phone: action.payload.user.phone || '',
                        typeId: action.payload.user.typeId || '',
                        typeLabel: action.payload.user.typeLabel || '',
                        roleId: action.payload.user.roleId || '',
                        roleLabel: action.payload.user.roleLabel || '',
                        welcomePage: action.payload.user.welcomePage || '',
                        admin: action.payload.user.admin || false
                    } : {})
                };
                
                state.isLoading = false;
                state.error = null;
            })
            // Master Login
            .addCase(masterLoginUser.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(masterLoginUser.rejected, (state, action) => {
                console.log(action.payload)
                state.error = action.payload?.message || "Errore sconosciuto.";
                state.isLoading = false;
            })
            .addCase(masterLoginUser.fulfilled, (state, action) => {
                state.isAuthenticated = true;
                state.token = action.payload.token;
                state.user = {
                    userId: action.payload.userId,
                    identityId: action.payload.identityId,
                    accountId: action.payload.accountId
                };
                state.isLoading = false;
                state.error = null;
            })
    }
})

// Esporto i selector
export const selectAuth = (state) => state.auth;
export const selectUser = (state) => state.auth.user;
export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;
export const selectAuthLoading = (state) => state.auth.isLoading;
export const selectAuthError = (state) => state.auth.error;

export const { clearError, getLogout, getLogged } = authSlice.actions;
export default authSlice.reducer;
